// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from '../actions';
import initialState from '../initialState';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as c from '../appConstants';

const sms_subscription = (state = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_SMS_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        SmsCreateIsProcessing: true,
      };
    case actions.CREATE_SMS_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        hideSmsSubscriptionForm: true,
        SmsCreateIsProcessing: false,
        statusMessage: c.SMS_CREATE_SUCCESS,
      };
    case actions.CREATE_SMS_SUBSCRIPTION_ERROR:
      return {
        ...state,
        SmsCreateIsProcessing: false,
        statusMessageError: c.SMS_CREATE_ERROR,
      };
    default:
      return state;
  }
};

export default sms_subscription;
